import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaAlumbrado from './TablaAlumbrado';

const Alumbrado: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaAlumbrado />
    </Box>
  );
};

export default Alumbrado;
